import { Callout } from '@radix-ui/themes';
import { InfoCircledIcon } from '@/components/icons';

export default function InfoCallout({ className, children }) {
  return (
    <Callout.Root color="blue" className={className}>
      <Callout.Icon>
        <InfoCircledIcon />
      </Callout.Icon>
      <Callout.Text>{children}</Callout.Text>
    </Callout.Root>
  );
}
